import { render, staticRenderFns } from "./sidewidth.vue?vue&type=template&id=2d0c8092&scoped=true"
import script from "./sidewidth.vue?vue&type=script&lang=js"
export * from "./sidewidth.vue?vue&type=script&lang=js"
import style0 from "./sidewidth.vue?vue&type=style&index=0&id=2d0c8092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c8092",
  null
  
)

export default component.exports